import React from 'react';

import { User } from 'api/endPoints/getReport';

import { Avatar } from 'components/common/Avatar/Avatar';
import { ForesightLogo } from 'components/common/ForesightLogo/ForesightLogo';

import { isTemplateBuiltByForesight } from 'components/widgets/ReportsHome/ReportsTemplates/ReportsTemplates.utils';
import classes from 'components/widgets/ReportsHome/ReportsTemplates/components/BuiltByBadge/BuiltByBadge.module.scss';

interface Props {
    user: User;
    showFullName?: boolean;
}

export const BuiltByBadge = ({ user, showFullName = true }: Props) => {
    if (!user) return null;

    if (isTemplateBuiltByForesight(user.email)) {
        return <ForesightLogo width={28} withBackground={true} />;
    }
    return (
        <div className={classes.userTitle}>
            <Avatar fullName={`${user.firstName} ${user.lastName}`} isUnassigned={false} className={classes.avatar} />
            {showFullName && <span>{`${user.firstName} ${user.lastName}`}</span>}
        </div>
    );
};
